import { render, staticRenderFns } from "./IpoFeeCalculator.vue?vue&type=template&id=2f5aab10"
import script from "./IpoFeeCalculator.vue?vue&type=script&lang=js"
export * from "./IpoFeeCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports